/* eslint-disable import/no-named-as-default-member */
// node modules
import React from 'react';

// app modules: components
import HeadContent from 'components/HeadContent';
import Layout from 'components/Layout';
import BlogPosts from 'components/BlogPosts';

async function action(_, params) {
  const { category: rawCategory, tags } = params;
  const category = rawCategory?.replace(/\+/g, ' ');

  return {
    chunks: ['blogs'],
    navigation: {
      heading: 'Features & Stories',
      section: 'Features',
    },
    component: (
      <Layout>
        <HeadContent
          contents={{
            title: category || 'Features & Stories',
            description:
              'Get the story behind the cookbook, read interviews with cookbook authors and discover great recipe ideas',
          }}
        />
        <BlogPosts
          allowHtmlDescription
          headingClassName="heading--size-32"
          infiniteScroll
          isPullable
          tags={tags ? tags.split(',').map(tag => tag.trim().replace(/\+/g, ' ')) : []}
          category={category}
        />
      </Layout>
    ),
  };
}

export default action;
